'use strict';

var React = require('react');
var reactFinalForm = require('react-final-form');
var PropTypes = require('prop-types');
var Boutton = require('@piconetworks/boutton');
var Form = require('@piconetworks/form');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Boutton__default = /*#__PURE__*/_interopDefaultLegacy(Boutton);
var Form__default = /*#__PURE__*/_interopDefaultLegacy(Form);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var style = {"label":"EmailPasswordlLogin-module_label__1yPcR","buttonLabel":"EmailPasswordlLogin-module_buttonLabel__Z4jbq","clickable":"EmailPasswordlLogin-module_clickable__e5rHK","field":"EmailPasswordlLogin-module_field__3CKOD","discountCode":"EmailPasswordlLogin-module_discountCode__1AMOL"};

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var testEmail = function testEmail(email) {
  if (!email) {
    return false;
  }

  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(email);
};

function _empty() {}

var fieldValidations = {
  email: function email(value) {
    return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(value) ? 'Invalid email address' : undefined;
  }
};

function _invokeIgnored(body) {
  var result = body();

  if (result && result.then) {
    return result.then(_empty);
  }
}

var composeValidators = function composeValidators() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return function (value) {
    return validators.reduce(function (error, validator) {
      return error || validator(value);
    }, undefined);
  };
};

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var EmailPasswordlLogin = function EmailPasswordlLogin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      fieldContainerProps = _ref.fieldContainerProps,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? null : _ref$description,
      name = _ref.name,
      hasPassword = _ref.hasPassword,
      _ref$linkColor = _ref.linkColor,
      linkColor = _ref$linkColor === void 0 ? '' : _ref$linkColor,
      _ref$contrastColor = _ref.contrastColor,
      contrastColor = _ref$contrastColor === void 0 ? '' : _ref$contrastColor,
      checkEmail = _ref.checkEmail,
      checkEmailPassword = _ref.checkEmailPassword,
      disabled = _ref.disabled,
      _ref$previewMode = _ref.previewMode,
      previewMode = _ref$previewMode === void 0 ? false : _ref$previewMode,
      _ref$customFieldsVali = _ref.customFieldsValid,
      customFieldsValid = _ref$customFieldsVali === void 0 ? true : _ref$customFieldsVali;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openPassword = _useState2[0],
      setOpenPassword = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showPassword = _useState4[0],
      togglePasswordVisibility = _useState4[1];

  var _useState5 = React.useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      emailWithPassword = _useState6[0],
      setEmailWithPassword = _useState6[1];

  var _useState7 = React.useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      errorMessage = _useState8[0],
      setErrorMessage = _useState8[1];

  React.useEffect(function () {
    if (hasPassword) {
      togglePasswordVisibility(true);
    }
  }, [hasPassword]);

  var processEmail = _async(function (email) {
    return _continueIgnored(_catch(function () {
      return _invokeIgnored(function () {
        if (testEmail(email)) {
          return _await(checkEmail({
            email: email
          }), function (emailStatus) {
            if (emailStatus !== null && emailStatus !== void 0 && emailStatus.hasPassword) {
              togglePasswordVisibility(true);
              setEmailWithPassword(emailStatus === null || emailStatus === void 0 ? void 0 : emailStatus.email);
            }
          });
        }
      });
    }, function (error) {
      console.error(error);
      setErrorMessage(error.message);
    }));
  });

  var processPassword = _async(function (password) {
    return _continueIgnored(_catch(function () {
      return _invokeIgnored(function () {
        if (!!password && !!emailWithPassword) {
          // Auth.creators.login
          return _awaitIgnored(checkEmailPassword({
            email: emailWithPassword,
            password: password
          }));
        }
      });
    }, function (error) {
      console.error(error);
      setErrorMessage(error.message);
    }));
  });

  var onEnterEmail = function onEnterEmail(e, emailAddress) {
    if (e.key === 'Enter' && customFieldsValid) {
      e.preventDefault();
      processEmail(emailAddress);
    }
  };

  var onEnterPassword = function onEnterPassword(e, password) {
    if (e.key === 'Enter') {
      e.preventDefault();
      processPassword(password);
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("p", null, description), /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, !showPassword && /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.field,
    style: {
      '--data-color': linkColor
    }
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    className: style.label
  }, "Enter your email"), /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({}, fieldContainerProps, {
    name: "".concat(name, ".emailAddress"),
    type: "text",
    placeholder: "name@domain.com",
    validate: composeValidators(fieldValidations.email),
    label: undefined
  }), function (_ref2) {
    var meta = _ref2.meta,
        input = _ref2.input,
        rest = _objectWithoutProperties(_ref2, ["meta", "input"]);

    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: style.discountCode
    }, /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Input, _extends({}, rest, {
      meta: meta,
      input: input,
      onFocus: function onFocus() {
        window.addEventListener('keydown', function (e) {
          return onEnterEmail(e, e.target.value);
        });
      },
      onBlur: function onBlur() {
        window.removeEventListener('keydown', function (e) {
          return onEnterEmail(e, e.target.value);
        });
      }
    })), /*#__PURE__*/React__default['default'].createElement(Boutton__default['default'], {
      variant: "primary",
      onClick: function onClick(e) {
        e.preventDefault();
        !previewMode && processEmail(input.value);
      },
      disabled: typeof input.value === 'undefined' || input.value === '' || !meta.valid || disabled,
      style: {
        color: contrastColor
      }
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      style: {
        color: 'white',
        fontSize: '26px'
      },
      className: "icon-right"
    })));
  })), showPassword && /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.field,
    style: {
      '--data-color': linkColor
    }
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    className: style.label
  }, /*#__PURE__*/React__default['default'].createElement("span", null, "Password"), /*#__PURE__*/React__default['default'].createElement("span", {
    className: style.clickable,
    style: {
      color: linkColor
    },
    onClick: function onClick() {
      return setOpenPassword(!openPassword);
    }
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "icon-icon_show",
    style: {
      fontSize: 20,
      marginRight: 10
    }
  }), openPassword ? 'Hide' : 'Show', " Password")), /*#__PURE__*/React__default['default'].createElement(reactFinalForm.Field, _extends({}, fieldContainerProps, {
    name: "".concat(name, ".password"),
    type: openPassword ? 'text' : 'password',
    label: undefined
  }), function (_ref3) {
    var meta = _ref3.meta,
        input = _ref3.input,
        rest = _objectWithoutProperties(_ref3, ["meta", "input"]);

    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: style.discountCode
    }, /*#__PURE__*/React__default['default'].createElement(Form__default['default'].Input, _extends({}, rest, {
      meta: meta,
      input: input,
      onFocus: function onFocus() {
        window.addEventListener('keydown', function (e) {
          return onEnterPassword(e, e.target.value);
        });
      },
      onBlur: function onBlur() {
        window.removeEventListener('keydown', function (e) {
          return onEnterPassword(e, e.target.value);
        });
      }
    })), /*#__PURE__*/React__default['default'].createElement(Boutton__default['default'], {
      variant: "primary",
      onClick: function onClick(e) {
        e.preventDefault();
        processPassword(input.value);
      },
      disabled: typeof input.value === 'undefined' || input.value === '' || !meta.valid || disabled,
      style: {
        backgroundColor: linkColor,
        color: contrastColor
      }
    }, /*#__PURE__*/React__default['default'].createElement("span", {
      style: {
        color: 'white',
        fontSize: '26px'
      },
      className: "icon-right"
    })));
  })), !!errorMessage && "".concat(errorMessage)));
};

function _continueIgnored(value) {
  if (value && value.then) {
    return value.then(_empty);
  }
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

EmailPasswordlLogin.propTypes = {
  fieldContainerProps: PropTypes__default['default'].any,
  description: PropTypes__default['default'].string,
  hasPassword: PropTypes__default['default'].bool,
  name: PropTypes__default['default'].string,
  required: PropTypes__default['default'].bool,
  previewMode: PropTypes__default['default'].bool,
  input: PropTypes__default['default'].any,
  linkColor: PropTypes__default['default'].string,
  contrastColor: PropTypes__default['default'].string,
  checkEmail: PropTypes__default['default'].func,
  checkEmailPassword: PropTypes__default['default'].func,
  disabled: PropTypes__default['default'].bool,
  customFieldsValid: PropTypes__default['default'].bool
};

module.exports = EmailPasswordlLogin;
